import { useState } from "react";
import { Sparkles, Send, Bot } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Spin } from "@/components/common";
import { btnNavy } from "@/components/MathShell";

export function AiDrafts({ kind, b, onResult }) {
  const [prompt, setPrompt] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/math/design/ai", { kind, prompt, grade: b.grade, type: b.type, count: 4 }); onResult(data.designs.map((d, k) => ({ id: `ai${Date.now()}${k}`, name: d.name || `AI öneri ${k + 1}`, design: d }))); toast.success(`${data.designs.length} AI taslak hazır`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-xl border p-3 space-y-2" data-testid={`ai-drafts-${kind}`}>
      <div className="font-bold text-navy flex items-center gap-2 text-sm"><Sparkles size={15} className="text-teal" /> AI taslak şablon üret</div>
      <textarea className="inp text-sm" rows={2} value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder={kind === "cover" ? "ör. 8. sınıf LGS, uzay temalı, lacivert-turuncu, iddialı" : "ör. ferah, yeni nesil, iki sütun, turkuaz başlık"} data-testid="ai-drafts-prompt" />
      <button onClick={run} disabled={busy} className={`${btnNavy} w-full py-2 text-sm flex items-center justify-center gap-1.5`} data-testid="ai-drafts-btn">{busy ? <Spin size={14} /> : <Sparkles size={14} />} 4 taslak üret</button>
    </div>
  );
}

export function DesignAssistant({ kind, design, onChanges }) {
  const [msgs, setMsgs] = useState([{ role: "asistan", text: kind === "cover" ? "Merhaba! Kapağı birlikte tasarlayalım. Ör: “başlığı büyüt, zemini koyu yeşil yap, formül deseni ekle”." : "Merhaba! Sayfa düzenini birlikte ayarlayalım. Ör: “daha ferah olsun, numaraları daire yap, filigran ekle”." }]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    const m = text.trim(); if (!m) return;
    const next = [...msgs, { role: "kullanıcı", text: m }]; setMsgs(next); setText(""); setBusy(true);
    try { const { data } = await api.post("/math/design/assistant", { kind, design, message: m, history: next.slice(-6) }); setMsgs([...next, { role: "asistan", text: data.reply }]); if (Object.keys(data.changes || {}).length) onChanges(data.changes); }
    catch (e) { setMsgs([...next, { role: "asistan", text: `Bir sorun oldu: ${errMsg(e)}` }]); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white rounded-xl border p-3 flex flex-col" data-testid={`design-assistant-${kind}`}>
      <div className="font-bold text-navy flex items-center gap-2 text-sm mb-2"><Bot size={16} className="text-teal" /> AI tasarım asistanı</div>
      <div className="space-y-2 max-h-56 overflow-y-auto scroll-thin mb-2" data-testid="assistant-messages">
        {msgs.map((x, k) => <div key={k} className={`text-xs rounded-lg px-3 py-2 ${x.role === "asistan" ? "bg-[#eef8f9] text-[#0f4c56]" : "bg-[#13294b] text-white ml-6"}`} data-testid={`assistant-msg-${k}`}>{x.text}</div>)}
        {busy && <div className="text-xs text-[#8a96a8] flex items-center gap-1"><Spin size={12} /> düşünüyor…</div>}
      </div>
      <div className="flex gap-2"><input className="inp text-sm" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Ne değiştireyim?" data-testid="assistant-input" />
        <button onClick={send} disabled={busy || !text.trim()} className={`${btnNavy} px-3`} data-testid="assistant-send-btn"><Send size={15} /></button></div>
    </div>
  );
}
